var _polygon, _polygon2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBetslipWinnerFun = function SvgBetslipWinnerFun(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "583.003px",
    height: "212.604px",
    viewBox: "0 0 583.003 212.604",
    enableBackground: "new 0 0 583.003 212.604",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.8511,
    y1: -273.698,
    x2: 874.0034,
    y2: -273.698,
    gradientTransform: "matrix(-1 0 0 -1 874.0029 -167.396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7163,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "95.582,212.604 95.582,212.603 333.032,212.603 517.152,212.603 392.003,0 333.032,0  95.582,0 0,0  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFB500",
    points: "426.669,0 552.003,212.604 583.003,212.604 583.003,0 552.003,0  "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetslipWinnerFun, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI1ODMuMDAzcHgiIGhlaWdodD0iMjEyLjYwNHB4IiB2aWV3Qm94PSIwIDAgNTgzLjAwMyAyMTIuNjA0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1ODMuMDAzIDIxMi42MDQiCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJCgkJPGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF8xXyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIzNTYuODUxMSIgeTE9Ii0yNzMuNjk4IiB4Mj0iODc0LjAwMzQiIHkyPSItMjczLjY5OCIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgODc0LjAwMjkgLTE2Ny4zOTYpIj4KCQk8c3RvcCAgb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojRkZCNTAwIi8+CgkJPHN0b3AgIG9mZnNldD0iMC43MTYzIiBzdHlsZT0ic3RvcC1jb2xvcjojRkZGRkZGO3N0b3Atb3BhY2l0eTowIi8+Cgk8L2xpbmVhckdyYWRpZW50PgoJPHBvbHlnb24gZmlsbD0idXJsKCNTVkdJRF8xXykiIHBvaW50cz0iOTUuNTgyLDIxMi42MDQgOTUuNTgyLDIxMi42MDMgMzMzLjAzMiwyMTIuNjAzIDUxNy4xNTIsMjEyLjYwMyAzOTIuMDAzLDAgMzMzLjAzMiwwIAoJCTk1LjU4MiwwIDAsMCAJIi8+Cgk8cG9seWdvbiBmaWxsPSIjRkZCNTAwIiBwb2ludHM9IjQyNi42NjksMCA1NTIuMDAzLDIxMi42MDQgNTgzLjAwMywyMTIuNjA0IDU4My4wMDMsMCA1NTIuMDAzLDAgCSIvPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };